import {
  Avatar,
  Badge,
  Button,
  Dropdown,
  Image,
  Layout,
  message,
  Modal,
  Select,
  Table,
  Tooltip,
} from "antd";
import React from "react";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import Cookies from "universal-cookie";
import MastersMenu from "./MastersMenu";
import TrackingMenus from "./TrackingMenus";
import ReportsMenus from "./ReportsMenus";
import { decode as base64_decode } from "base-64";
import LaunchingDashboard from "./LaunchingDashboard";
import EmailMenu from "./EmailMenu";
import BookingMenu from "./BookingMenu";
import AlertMenu from "./AlertMenu";
import SettingsMenus from "./SettingsMenus";
import GraphsMenus from "./GraphsMenus";
import WasteManageMenus from "./WasteManageMenus";
import logoIcon from "../assets/images/userPhoto.jpg";
import { Content } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import chevronDown from "../assets/images/NewDesign/chevron-down.svg";
import menuSettings from "../assets/images/NewDesign/menuSettings.svg";
import Help from "../assets/images/NewDesign/Help.svg";
import changepassword from "../assets/images/NewDesign/change-password.svg";
import driverbehaviour from "../assets/images/NewDesign/driver-behaviour.svg";
import signout from "../assets/images/NewDesign/sign-out.svg";
import MenuSettingStore from "../store/MenuSettingStore";
import config from "../config";

import HelpModal from "./HelpModal";
import AiMenu from "./AiMenu";
import GatewayMenu from "./GatewayMenu";
import cloudDownload from "../assets/images/CloudDownload 1.svg";
import SosAlertStore from "../store/SosAlertStore";
import { AlertOutlined } from "@ant-design/icons";
import SosAlertNotification from "./SosAlertNotification";
const { Option } = Select;
const { Header } = Layout;
class Menu3 extends React.Component {
  constructor(props, context) {
    super(props);
    this.cookies = new Cookies();

    this.menuSettingStore = new MenuSettingStore(this);
    this.sosAlertStore = new SosAlertStore(this);

    this.rolePermission2 = JSON.parse(localStorage.getItem("rolePermission2"));
    //console.log(this.rolePermission2.companymenusetting)

    let masterChildren = [];
    let trackingChildren = [];
    let reportChildren = [];
    let emailReportChildren = [];
    let settingChildren = [];
    let alertChildren = [];
    let graphChildren = [];
    let aiChildren = [];
    let gatewayChildren = [];
    let bookingChildren = [];

    Object.entries(this.rolePermission2).forEach(([key, value]) => {
      if (value.parentId === 1) {
        masterChildren.push(value.moduleId);
      }
      if (value.parentId === 41) {
        trackingChildren.push(value.moduleId);
      }
      if (value.parentId === 56) {
        reportChildren.push(value.moduleId);
      }
      if (value.parentId === 138) {
        emailReportChildren.push(value.moduleId);
      }
      if (value.parentId === 140) {
        settingChildren.push(value.moduleId);
      }
      if (value.parentId === 161) {
        alertChildren.push(value.moduleId);
      }
      if (value.parentId === 162) {
        graphChildren.push(value.moduleId);
      }
      if (value.parentId === 200) {
        aiChildren.push(value.moduleId);
      }
      if (value.parentId === 203) {
        bookingChildren.push(value.moduleId);
      }
      if (value.parentId === 211 && config.project == "saudi") {
        gatewayChildren.push(value.moduleId);
      }
      if (value.parentId === 216) {
        gatewayChildren.push(value.moduleId);
      }
    });
    //console.log(bookingChildren)

    this.rolePermission3 = JSON.parse(localStorage.getItem("rolePermission3"));
    this.rolePermission = JSON.parse(localStorage.getItem("rolePermission"));

    this.accountChildren = [];
    this.vehicleManagement = [];
    this.fuelManagement = [];
    this.schoolManagement = [];
    this.jobManagement = [];
    this.tripmanagement = [];
    this.trackingReport = [];
    this.miscellaneousReport = [];
    this.adminReport = [];
    this.driverReport = [];
    this.fleetReport = [];
    this.alertReport = [];
    this.taxiManagement = [];
    this.warehouseManagement = [];
    this.inventoryManagement = [];
    this.trackingManagement = [];
    this.emailManagement = [];
    this.settingsManagement = [];
    this.alertManagement = [];
    this.graphsManagement = [];
    this.aiManagement = [];
    this.gatewayManagement = [];
    this.bookingManagement = [];
    this.bookingReport = [];

    const removedReports = ["inventorystatusrepostlist"];
    // console.log(this.rolePermission2);
    this.showMaster = false;
    this.showTracking = false;
    this.showReport = false;
    this.showEmailReport = false;
    this.showSetting = false;
    this.showAlert = false;
    this.showGraph = false;
    this.showAi = false;
    this.showGateway = false;
    this.showBooking = false;

    Object.entries(this.rolePermission2).forEach(([key, item]) => {
      if (masterChildren.includes(item.parentId) && item.canView == 1) {
        this.showMaster = true;
      }

      if (trackingChildren.includes(item.moduleId) && item.canView == 1) {
        this.showTracking = true;
      }
      if (reportChildren.includes(item.parentId) && item.canView == 1) {
        this.showReport = true;
      }
      if (emailReportChildren.includes(item.moduleId) && item.canView == 1) {
        this.showEmailReport = true;
      }
      if (settingChildren.includes(item.moduleId) && item.canView == 1) {
        this.showSetting = true;
      }
      if (alertChildren.includes(item.moduleId) && item.canView == 1) {
        this.showAlert = true;
      }
      if (graphChildren.includes(item.moduleId) && item.canView == 1) {
        this.showGraph = true;
      }
      if (aiChildren.includes(item.moduleId) && item.canView == 1) {
        this.showAi = true;
      }
      if (gatewayChildren.includes(item.moduleId) && item.canView == 1) {
        this.showGateway = true;
      }
      if (bookingChildren.includes(item.moduleId) && item.canView == 1) {
        this.showBooking = true;
      }
      if (removedReports.includes(item.path)) {
        return;
      }
      if (item.parentId == 2 && item.canView == 1) {
        this.accountChildren.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      if (item.parentId == 8 && item.canView == 1) {
        this.vehicleManagement.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
        // console.log(item.language)
      }
      if (item.parentId == 21 && item.canView == 1) {
        this.fuelManagement.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      const saudirestrictedPaths = [
        "studentlist",
        "studenttripList",
        "studentrouteList",
        "parentComplaintList",
      ];
      if (item.parentId == 24 && item.canView == 1) {
        if (item.path !== "passengerList2") {
          if (
            config.project === "saudi" ||
            !saudirestrictedPaths.includes(item.path)
          ) {
            this.schoolManagement.push({
              key: item.path,
              label: context.translate(
                item.language ? item.language : item.path
              ),
            });
          }
        }
      }
      if (item.parentId == 29 && item.canView == 1) {
        this.jobManagement.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      if (item.parentId == 32 && item.canView == 1) {
        this.tripmanagement.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      // if (item.parentId == 203 && item.canView == 1) {
      //   this.bookingManagement.push({
      //     key: item.path,
      //     label: context.translate(item.language ? item.language : item.path),
      //   });
      // }
      // console.log(this.bookingManagement)
      if (item.parentId == 57 && item.canView == 1) {
        this.trackingReport.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      if (item.parentId == 58 && item.canView == 1) {
        this.miscellaneousReport.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      if (item.parentId == 149 && item.canView == 1) {
        this.adminReport.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      const saudiprojectRestrictedReports = [
        "taxiViolationReport",
        "shiftlogreport",
      ];
      if (item.parentId == 213 && item.canView == 1) {
        const isRestrictedReport = saudiprojectRestrictedReports.includes(
          item.path
        );
        if (!isRestrictedReport || config.project === "saudi") {
          this.bookingReport.push({
            key: item.path,
            label: context.translate(item.language ?? item.path),
          });
        }
      }
      if (item.parentId == 59 && item.canView == 1) {
        this.driverReport.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }

      if (item.parentId == 60 && item.canView == 1) {
        this.fleetReport.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }

      if (item.parentId == 61 && item.canView == 1) {
        //console.log(item.path);
        this.alertReport.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }

      if (item.parentId == 192 && item.canView == 1) {
        this.taxiManagement.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      if (item.parentId == 37 && item.canView == 1) {
        this.warehouseManagement.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      if (item.parentId == 39 && item.canView == 1) {
        this.inventoryManagement.push({
          key: item.path,
          label: context.translate(item.language ? item.language : item.path),
        });
      }
      if (item.parentId == 41 && item.canView == 1) {
        this.trackingManagement.push(item.path);
      }

      if (item.parentId == 138 && item.canView == 1) {
        this.emailManagement.push(item.path);
      }
      if (item.parentId == 203 && item.canView == 1) {
        this.bookingManagement.push(item.path);
      }
      if (item.parentId == 140 && item.canView == 1) {
        this.settingsManagement.push(item.path);
      }
      if (item.parentId == 161 && item.canView == 1) {
        this.alertManagement.push(item.path);
      }

      if (item.parentId == 200 && item.canView == 1) {
        this.aiManagement.push(item.path);
      }
      if (item.parentId == 162 && item.canView == 1) {
        this.graphsManagement.push(item.path);
      }
      if (item.parentId == 211 && item.canView == 1) {
        this.gatewayManagement.push(item.path);
      }
      if (item.parentId == 216 && item.canView == 1) {
        this.gatewayManagement.push(item.path);
      }
    });

    //console.log(this.vehicleManagement);

    this.state = {
      openMastersCard: false,
      openTrackingWindow: false,
      openReportsWindow: false,
      openEmailWindow: false,
      openSettingsWindow: false,
      openAlertWindow: false,
      openGraphsWindow: false,
      openWasteManageWindow: false,
      openGatewayWindow: false,
      showHelpModal: false,

      showSearchInput: false,
      showNotificationModal: false,
      sosnotificationCount: 0,
      columns: [
        {
          title: context.translate("_VEHICLE_NUMBER_"),
          dataIndex: "vehicleNo",
          width: "20%",
          // elli
        },
        {
          title: context.translate("_DRIVER_NAME_"),
          dataIndex: "driverName",
          width: "20%",
        },
        {
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_NAME_"),
          dataIndex: "ruleName",
          width: "30%",
          render: (val, record) => {
            if (record.ruleSelectorId == 15) {
              return <>Geofence({record.fence})</>;
            } else {
              return val;
            }
          },
        },
        {
          title: context.translate("_TIME_"),
          dataIndex: "time",
          width: "20%",
        },
        {
          title: context.translate("_FLEET_DASHBORD_DROWGEO_ADDRESS_"),
          dataIndex: "address",
          width: "50%",
        },
      ],

      hoveredItem: null,
      activeWindow: null,
      photo: props.getUserData().photo,
      companyPhoto: props.getUserData().logo,
      pageTitle: this.accountChildren.find(
        (item) => item.key === props.location.pathname.replace(/^\//, "")
      )?.label,
      selectedNotificationId: [],
      loadData: 0,
      notificationCount: 0,
      isEmergency: false,
      sosCount: 0,
      showSosAlerts: false,

    };
  }

  updateTitle = (newTitle) => {
    // console.log(newTitle)
    this.setState({ pageTitle: newTitle });
    localStorage.setItem("pageTitle", newTitle);
  };

  handleDropdownClick = (items) => {
    if (items === "logout") {
      this.props.navigate("/login");
    } else if (items.key === "helpcenter") {
      this.setState({ showHelpModal: true });
    } else {
      let key = items.key;
      this.props.navigate("/" + key);
    }
  };

  handleMouseEnter = (item, windowName) => {
    this.setState({
      hoveredItem: item,
      activeWindow: windowName, // Only open one window at a time
    });
  };

  handleMouseLeave = () => {
    this.setState({ hoveredItem: null });
  };
  async handleMenuSearch(val, searchData) {
    this.props.navigate("/" + searchData.path);
  }

  async dismissNotification() {
    if (this.state.selectedNotificationId.length === 0) {
      message.error("Please select notification to dismiss");
      return;
    }
    const response = await this.menuSettingStore.dismissNotification({
      companyId: this.props.getUserData().userCompanyId,
      userId: this.props.getUserData().userId,
      ids: this.state.selectedNotificationId,
    });
    if (response.success === "S") {
      const data = await this.menuSettingStore.getNotificationRule({
        companyId: this.props.getUserData().userCompanyId,
      });
      this.setState({ notificationCount: data.totalCount });
      message.success("Notification dismissed successfully");
    } else {
      message.error("Notification dismiss failed");
    }
  }

  async componentDidMount() {
    document.body.style.direction =
      this.context.locale.language === "arabic" ? "rtl" : "ltr";
    // this.context.locale.language === "english" ? "ltr" : "rtl";
    if (this.props.getUserData().isadmin === 1 && config.pythonReport !== 1) {
      this.getSOSAlert();

      if (!this.sosinterval) {
        this.sosinterval = setInterval(() => {
          this.getSOSAlert();
        }, 60000);
      }
    }

  }

  handleEmergencyClick = () => {
    this.props.navigate("/livetracking");
  }
  getSOSAlert = async () => {
    // console.log("getsosalert")
    // if (this.props.getUserData().isadmin === 1) {
    await this.sosAlertStore.loadData({
      companyId: this.props.getUserData().userCompanyId,
      userId: this.props.getUserData().userId,
      rule: 0
    });
    // console.log(this.sosAlertStore.total, this.props.location.pathname)
    this.setState({
      isEmergency: this.sosAlertStore.total > 0 ? true : false,
      sosnotificationCount: this.sosAlertStore.total || 0,

    })


  }


  render() {
    const encodedCookieData = this.cookies.get("data");

    const isIaunchingDashboard = JSON.parse(
      base64_decode(encodedCookieData)
    ).showLaunchingDashboard;

    const { hoveredItem, activeWindow } = this.state;
    const dropdownItems = [
      {
        key: "profile",
        label: (
          <>
            {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Avatar
                src={
                  this.state.photo
                    ? config.fleetURL + "/images/users/" + this.state.photo
                    : logoIcon
                }
                // src={logoIcon}
                size={35}
              />
              <div>
                <div style={{ marginInlineEnd: "10px", color: "white" }}>
                  {JSON.parse(base64_decode(encodedCookieData)).userName}
                </div>
                <span
                  style={{
                    marginInlineEnd: "10px",
                    color: "#797979",
                    fontSize: "12px",
                  }}
                >
                  Online
                </span>
              </div>
            </div>
            <div
              className="menu-items-custom"
              style={{
                width: "100%",
                height: "0.1px",
                background: "#34343A",
                marginTop: "10px",
                fontSize: "12px",
              }}
            />
          </>
        ),
        type: "group",
      },

      (this.rolePermission2?.companymenusetting?.canView === 1 && Number(this.props.getUserData().isadmin) != 0) && {
        key: "companymenusetting",
        label: this.context.translate("_MENU_SETTING_"),
        icon: (
          <Image
            style={{ height: "16px", width: "16px" }}
            src={menuSettings}
          ></Image>
        ),
      },
      {
        key: "helpcenter",
        label: this.context.translate("_HELP_CENTER_"),
        icon: (
          <Image style={{ height: "16px", width: "16px" }} src={Help}></Image>
        ),
      },
      {
        key: "companychangepassword",
        label: this.context.translate("_FLEET_MANAGEUSER_CHANGEPASSWORD_TAB_"),
        icon: (
          <Image
            style={{ height: "16px", width: "16px" }}
            src={changepassword}
          ></Image>
        ),
      },
      this.rolePermission2?.companydriverbehaviorsetting?.canView === 1 && {
        key: "companydriverbehaviorsetting",
        label: this.context.translate("_DRIVER_BEHAVIOR_SETTINGS_"),
        icon: (
          <Image
            style={{ height: "16px", width: "16px" }}
            src={driverbehaviour}
          ></Image>
        ),
      },
      {
        key: "logout",
        label: (
          <>
            <div
              style={{
                width: "100%",
                height: "0.1px",
                background: "#34343A",
                marginBottom: "10px",
              }}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => this.handleDropdownClick("logout")}
            >
              <Avatar
                style={{
                  height: "16px",
                  width: "16px",
                  marginInlineEnd: "10px",
                }}
                src={signout}
              />
              <div style={{ color: "white", fontSize: "12px" }}>
                {this.context.translate("_SIGN_OUT_")}
              </div>
            </div>
          </>
        ),
        type: "group",
      },
    ];
    const { isEmergency } = this.state;


    return (
      <>
        {/* {console.log(isIaunchingDashboard)} */}

        {isIaunchingDashboard ? (
          <LaunchingDashboard />
        ) : (
          <div
            style={{
              display: "flex",
              overflow: "hidden",
              height: "100vh",
              backgroundColor: "#F8FAFC",
            }}
          >
            <Layout
              className="menu-layout"
              style={{
                background: "#07163D",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <Image
                  style={{
                    height: "50px",
                    width: "50px",
                    marginBottom: "5px",
                  }}
                  // src={
                  //   // require("../assets/images/NewDesign/locaion-icon 2.png")

                  //   this.state.companyPhoto
                  //     ? config.fleetURL +
                  //     "/images/companylogo/" +
                  //     this.state.companyPhoto
                  //     : config.project == "proawtltrack"
                  //       ? require("../assets/images/NewDesign/sphere.png")
                  //       : config.project == "ctrax"
                  //         ? require("../assets/images/NewDesign/ctrax-inner.png")

                  //         : config.project == "intellicab"
                  //           ? require("../assets/images/NewDesign/intellicab_lg.png")

                  //           : require("../assets/images/logo_icon.png")
                  // }
                  src={
                    this.state.companyPhoto
                      ? config.fleetURL +
                      "/images/companylogo/" +
                      this.state.companyPhoto :
                      `/logos/${config.project}-innerlogo.png`
                  }
                />
              </div>

              <div
                style={{ width: "100%", height: "0.2px", background: "white" }}
              />

              {this.showMaster && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("box", "MastersMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() =>
                      this.setState((prevState) => ({
                        activeWindow:
                          prevState.activeWindow === "MastersMenu"
                            ? null
                            : "MastersMenu",
                      }))
                    }
                  >
                    <Image
                      style={{
                        width: "24px",
                        height: "24px",
                        flexShrink: 0,
                        aspectRatio: 1 / 1,
                      }}
                      src={
                        hoveredItem === "box"
                          ? require("../assets/images/NewDesign/box-fill.png")
                          : require("../assets/images/NewDesign/box.png")
                      }
                    />
                    <Image
                      //   className="menu-items-img-arrow"
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "MastersMenu" && (
                    <MastersMenu
                      accountChildren={this.accountChildren}
                      fuelManagement={this.fuelManagement}
                      schoolManagement={this.schoolManagement}
                      jobManagement={this.jobManagement}
                      taxiManagement={this.taxiManagement}
                      tripmanagement={this.tripmanagement}
                      warehouseManagement={this.warehouseManagement}
                      inventoryManagement={this.inventoryManagement}
                      vehicleManagement={this.vehicleManagement}
                      updateTitle={this.updateTitle}
                      rolePermission={this.rolePermission}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}
              {this.showTracking && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("geo", "TrackingMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() =>
                      this.setState((prevState) => ({
                        activeWindow:
                          prevState.activeWindow === "TrackingMenu"
                            ? null
                            : "TrackingMenu",
                      }))
                    }
                  >
                    <Image
                      style={{ width: "24px", height: "27px", flexShrink: 0 }}
                      src={
                        hoveredItem === "geo"
                          ? require("../assets/images/NewDesign/geo-fill.png")
                          : require("../assets/images/NewDesign/geo.png")
                      }
                    />
                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "TrackingMenu" && (
                    <TrackingMenus
                      updateTitle={this.updateTitle}
                      trackingManagement={this.trackingManagement}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {this.showReport && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("clipboard", "ReportsMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() =>
                      this.setState((prevState) => ({
                        activeWindow:
                          prevState.activeWindow === "ReportsMenu"
                            ? null
                            : "ReportsMenu",
                      }))
                    }
                  >
                    <Image
                      style={{
                        width: "24px",
                        height: "24px",
                        flexShrink: 0,
                      }}
                      src={
                        hoveredItem === "clipboard"
                          ? require("../assets/images/NewDesign/clipboard-filll.png")
                          : require("../assets/images/NewDesign/clipboard.png")
                      }
                    />

                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>
                  {activeWindow === "ReportsMenu" && (
                    <ReportsMenus
                      trackingReport={this.trackingReport}
                      miscellaneousReport={this.miscellaneousReport}
                      adminReport={this.adminReport}
                      driverReport={this.driverReport}
                      fleetReport={this.fleetReport}
                      alertReport={this.alertReport}
                      bookingReport={this.bookingReport}
                      updateTitle={this.updateTitle}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {this.showEmailReport && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("envelope", "EmailMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <Image
                      style={{
                        width: "24px",
                        height: "24px",
                        flexShrink: 0,
                        aspectRatio: 1 / 1,
                      }}
                      src={
                        hoveredItem === "envelope"
                          ? require("../assets/images/NewDesign/envelope-fill.png")
                          : require("../assets/images/NewDesign/envelope.png")
                      }
                    />
                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "EmailMenu" && (
                    <EmailMenu
                      emailManagement={this.emailManagement}
                      updateTitle={this.updateTitle}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {this.showSetting && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("gear", "SettingsMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <Image
                      style={{ width: "24px", height: "24px", flexShrink: 0 }}
                      src={
                        hoveredItem === "gear"
                          ? require("../assets/images/NewDesign/gear-fill.png")
                          : require("../assets/images/NewDesign/gear.png")
                      }
                    />
                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "SettingsMenu" && (
                    <SettingsMenus
                      settingsManagement={this.settingsManagement}
                      updateTitle={this.updateTitle}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {this.showAlert && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("exclamation", "AlertMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <Image
                      style={{
                        width: "24px",
                        height: "24px",
                        flexShrink: 0,
                        aspectRatio: 1 / 1,
                      }}
                      src={
                        hoveredItem === "exclamation"
                          ? require("../assets/images/NewDesign/exclamation-triangle-fill.png")
                          : require("../assets/images/NewDesign/exclamation-triangle.png")
                      }
                    />
                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "AlertMenu" && (
                    <AlertMenu
                      updateTitle={this.updateTitle}
                      alertManagement={this.alertManagement}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {this.showGraph && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("pie-chart", "GraphsMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <Image
                      style={{ width: "24px", height: "24px", flexShrink: 0 }}
                      src={
                        this.state.hoveredItem === "pie-chart"
                          ? require("../assets/images/NewDesign/pie-chart-fill.png")
                          : require("../assets/images/NewDesign/pie-chart.png")
                      }
                    />
                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "GraphsMenu" && (
                    <GraphsMenus
                      updateTitle={this.updateTitle}
                      graphsManagement={this.graphsManagement}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {this.showAi && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("aiIcon", "AiMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <Image
                      style={{
                        width: "24px",
                        height: "24px",
                        flexShrink: 0,
                        aspectRatio: 1 / 1,
                      }}
                      src={
                        hoveredItem === "aiIcon"
                          ? require("../assets/images/NewDesign/AI/AifillIcon.png")
                          : require("../assets/images/NewDesign/AI/AiIcon.png")
                      }
                    />
                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "AiMenu" && (
                    <AiMenu
                      updateTitle={this.updateTitle}
                      aiManagement={this.aiManagement}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {this.showGateway && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("gateway", "GatewayMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <Image
                      style={{
                        width: "27px",
                        height: "27px",
                        flexShrink: 0,
                        aspectRatio: 1 / 1,
                        filter: "brightness(0) invert(1)",
                      }}
                      src={
                        hoveredItem === "gateway"
                          ? require("../assets/images/NewDesign/gatewayfill.png")
                          : require("../assets/images/NewDesign/gateway.png")
                      }
                    />
                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images//NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "GatewayMenu" && (
                    <GatewayMenu
                      gatewayManagement={this.gatewayManagement}
                      updateTitle={this.updateTitle}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {this.showBooking && (
                <div>
                  <div
                    className="menu-items"
                    onMouseEnter={() =>
                      this.handleMouseEnter("booking", "BookingMenu")
                    }
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <Image
                      style={{
                        width: "27px",
                        height: "27px",
                        flexShrink: 0,
                        aspectRatio: 1 / 1,
                        filter: "brightness(0) invert(1)",
                      }}
                      src={
                        hoveredItem === "booking"
                          ? require("../assets/images/NewDesign/taxi.png")
                          : require("../assets/images/NewDesign/taxi-fill.png")
                      }
                    />
                    <Image
                      style={{ width: "14px", height: "14px", flexShrink: 0 }}
                      src={require("../assets/images/NewDesign/chevron-right.png")}
                    />
                  </div>

                  {activeWindow === "BookingMenu" && (
                    <BookingMenu
                      bookingManagement={this.bookingManagement}
                      updateTitle={this.updateTitle}
                      closeMenu={() => this.setState({ activeWindow: null })}
                    />
                  )}
                </div>
              )}

              {/* <div>
                <div
                  className="menu-items"
                  onMouseEnter={() =>
                    this.handleMouseEnter("trash", "TrashMenu")
                  }
                  onMouseLeave={this.handleMouseLeave}
                >
                  <Image
                    style={{
                      width: "24px",
                      height: "24px",
                      flexShrink: 0,
                      aspectRatio: 1 / 1,
                    }}
                    src={
                      hoveredItem === "trash"
                        ? require("../assets/images/NewDesign/trash3-fill.png")
                        : require("../assets/images/NewDesign/trash3.png")
                    }
                  />
                  <Image
                    style={{ width: "14px", height: "14px", flexShrink: 0 }}
                    src={require("../assets/images/NewDesign/chevron-right.png")}
                  />
                </div>
                {activeWindow === "TrashMenu" && (
                  <WasteManageMenus
                    updateTitle={this.updateTitle}
                    closeMenu={() => this.setState({ activeWindow: null })}
                  />
                )}
              </div> */}
            </Layout>
            <Layout
              style={{
                width: "93%",
                margin: "10px",
                zIndex: 0,
                backgroundColor: "#F8FAFC",
              }}
            >
              <Header className="screen-header">
                <div className="screen-top">
                  {" "}

                  {
                    this.accountChildren.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.trackingReport.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.miscellaneousReport.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.adminReport.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.fuelManagement.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.schoolManagement.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.jobManagement.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.taxiManagement.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.warehouseManagement.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.inventoryManagement.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.tripmanagement.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.vehicleManagement.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.driverReport.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.fleetReport.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {
                    this.alertReport.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }

                  {

                    this.bookingReport.find(
                      (item) =>
                        item.key ===
                        this.props.location.pathname.replace(/^\//, "")
                    )?.label
                  }
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "companymenusetting"
                    ? this.context.translate("_MENU_SETTING_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "livetracking"
                    ? this.context.translate("_LIVE_TRACING_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "AdvanceDashboard"
                    ? this.context.translate("_ADVANCE_DASHBOARD_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "alertlist"
                    ? this.context.translate("_ALERT_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "detailtracking"
                    ? this.context.translate("_DETAIL_TRACKING_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "vehiclelist/4"
                    ? this.context.translate("_VEHICLE_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") === "heatmap"
                    ? this.context.translate("_HEAT_MAP_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "EmailReportList"
                    ? this.context.translate("_EMAIL_REPORT_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "bookinglist"
                    ? this.context.translate("_BOOKING_DASHBOARD_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "trackbygroup"
                    ? this.context.translate("_TRACK_BY_GROUP_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "multitracking"
                    ? this.context.translate("_MULTI_TRACKING_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "liveroutepath"
                    ? this.context.translate("_LIVE_ROUTE_PATH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "temperaturedashboard"
                    ? this.context.translate("_TEMPERATURE_DASHBOARD_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "dashboard"
                    ? this.context.translate("_DASHBOARD_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "maintenancedashboard"
                    ? this.context.translate("_MAINTENANCE_DASHBOARD_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "historytracking"
                    ? this.context.translate("_HISTORY_TRACKING_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "sensorreportlist"
                    ? this.context.translate("_SENSOR_REPORT_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "warehousemonitoring"
                    ? this.context.translate("_WAREHOUSE_MONITORING_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "videomonitoring"
                    ? this.context.translate("_VIDEO_MONITORING_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "evidence"
                    ? this.context.translate("_EVIDENCE_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "multivideomonitoring"
                    ? this.context.translate("_MULTI_VIDEO_MONITORING_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "notificationlist"
                    ? this.context.translate("_NOTIFICATION_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") === "simlist"
                    ? this.context.translate("_SIM_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "deviceloglist"
                    ? this.context.translate("_DEVICE_LOG_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "emailmessage"
                    ? this.context.translate(
                      "_FLEET_RULEADMIN_RULEDETAIL_EMAILMESSAGE_"
                    )
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "inspectionlist"
                    ? this.context.translate("_INSPECTION_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "gprscommand"
                    ? this.context.translate("_GPRS_COMMAND_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "addLocation"
                    ? this.context.translate("_ADD_LOCATION_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") === "faqList"
                    ? this.context.translate("_FAQ_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "predefinedMesssage"
                    ? this.context.translate("_PREDEFINED_MESSAGES_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "devicelist"
                    ? this.context.translate("_FLEET_GROUP_GROUPLIST_TITLE_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "companychangepassword"
                    ? this.context.translate(
                      "_FLEET_MANAGEUSER_CHANGEPASSWORD_TAB_"
                    )
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "geofencereportlist"
                    ? this.context.translate("_GEOFENCE_MANAGEMENT_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "SpeedGraph"
                    ? this.context.translate("_SPEED_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "DistanceGraph"
                    ? this.context.translate("_DISTANCE_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "IdleGraph"
                    ? this.context.translate("_IDLE_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "ExIdleGraph"
                    ? this.context.translate("_EXIDLE_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "UsageGraph"
                    ? this.context.translate("_USAGE_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "TempGraph"
                    ? this.context.translate("_TEMPERATURE_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "DashboardGraph"
                    ? this.context.translate("_DASHBOARD_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "FuelGraph"
                    ? this.context.translate("_FUEL_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "DriverScoreGraph"
                    ? this.context.translate("_DRIVER_SCORE_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "MaxSpeedGraph"
                    ? this.context.translate("_MAX_SPEED_GRAPH_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "companydriverbehaviorsetting"
                    ? this.context.translate("_DRIVER_BEHAVIOR_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "vehicleodometerrecords"
                    ? this.context.translate("_ODOMETER_RECORDS_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "aidashboard"
                    ? this.context.translate("_AI_DASHBOARD_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "AiAssistant"
                    ? this.context.translate("_AI_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "waslcompanylist"
                    ? this.context.translate("_WASL_COMPANY_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "waslstation"
                    ? this.context.translate("_STATION_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "wasldriverlist"
                    ? this.context.translate("_WASL_DRIVER_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "waslvehiclelist"
                    ? this.context.translate("_WASL_VEHICLE_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "wasltrip"
                    ? this.context.translate("_WASL_TRIP_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "companylist"
                    ? this.context.translate("_COMPANY_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "PythonReportList"
                    ? this.context.translate("_REPORT_LIST_")
                    : null}
                  {this.props.location.pathname.replace(/^\//, "") ===
                    "gatewayDashboard"
                    ? this.context.translate("_GATEWAY_DASHBOARD_")
                    : null}

                  {this.props.location.pathname.replace(/^\//, "") ===
                    "plotStudentsOnMap"
                    ? this.context.translate("_PLOT_STUDENTS_ON_MAP_")
                    : null}
                  {/* {this.props.location.pathname.replace(/^\//, "") ===
                  "paymentlist"
                    ? this.context.translate("_PAYMENT_LIST_")
                    : null} */}
                  <div>
                    {/* {console.log("sos alert count", this.sosAlertStore.total)} */}
                    {(isEmergency && this.sosAlertStore.total > 0) && (
                      <Tooltip title={this.context.translate("_SOS_ALERT_")}>
                        <Badge dot style={{ marginInlineEnd: '10px' }}
                        >
                          <AlertOutlined onClick={this.handleEmergencyClick} className="emergency-icon" />
                        </Badge>
                      </Tooltip>
                    )}
                    {this.state.showSearchInput && (
                      <Select
                        onChange={(val, option) => {
                          const fullData = option?.fullData;

                          this.handleMenuSearch(val, fullData);
                        }}
                        showSearch
                        placeholder={this.context.translate("_GLOBAL_SEARCH_")}
                        className="globalSearch"
                        style={{ width: 200, marginRight: 10 }}
                        filterOption={(inputValue, option) => {
                          if (option.children) {
                            return (
                              option.children
                                .toLowerCase()
                                .indexOf(inputValue.toLowerCase()) >= 0
                            );
                          }
                        }}
                      >
                        {this.menuSettingStore?.searchMenusList?.map((val) => {
                          return (
                            <Option
                              key={val.moduleId}
                              fullData={val}
                              value={val.moduleId}
                            >
                              {val.name}
                            </Option>
                          );
                        })}
                      </Select>
                    )}
                    <Image
                      style={{
                        height: "22px",
                        width: "22px",
                        marginLeft: 0,
                        marginRight: 10,
                        cursor: "pointer",
                      }}
                      src={require("../assets/images/NewDesign/Search.png")}
                      onClick={() => {
                        this.setState({ showSearchInput: true });
                      }}
                    ></Image>

                    <Badge
                      count={this.state.notificationCount || 0}
                      size="small"
                      className="notification-badge-class"
                    >
                      <Image
                        style={{
                          height: "22px",
                          width: "22px",
                          marginLeft: 0,
                          marginRight: 10,
                          cursor: "pointer",
                        }}
                        src={require("../assets/images/NewDesign/bell.png")}
                        onClick={() => {
                          this.setState({ showNotificationModal: true });
                        }}
                      />
                    </Badge>
                    {config.project == "proawtltrack" && (
                      <Badge size="small" className="notification-badge-class">
                        <Tooltip
                          title={this.context.translate("_DOWNLOAD_REPORT_LIST_")}
                          placement="bottom"
                        >
                          <Image
                            style={{
                              height: "22px",
                              width: "22px",
                              marginLeft: 0,
                              marginRight: 10,
                              cursor: "pointer",
                              fill: "white",
                            }}
                            preview={false}
                            // src={require("../assets/images/NewDesign/Pi7_cloud-computing.png")}
                            src={cloudDownload}
                            onClick={() => {
                              window.open(
                                config.PythonReportList + "/PythonReportList",
                                "_blank"
                              );
                            }}
                          />
                        </Tooltip>
                      </Badge>
                    )}


                    <Image
                      style={{ width: 40, marginLeft: 0, marginRight: 10 }}
                      // src={logoIcon}
                      src={
                        this.state.photo
                          ? config.fleetURL +
                          "/images/users/" +
                          this.state.photo
                          : logoIcon
                      }
                    ></Image>

                    <Dropdown
                      className="menu-dropdown"
                      menu={{
                        items: dropdownItems,
                        onClick: (items) => this.handleDropdownClick(items),
                      }}
                      // trigger={["click"]}
                      overlayClassName="custom-dropdown"
                    // onClick={(items) => this.handleDropdownClick(items)}
                    >
                      <Avatar
                        src={chevronDown}
                        size={40}
                        style={{
                          height: "22px",
                          width: "22px",
                          marginLeft: 0,
                          marginRight: 10,
                          cursor: "pointer",
                        }}
                      />
                    </Dropdown>
                  </div>
                </div>
              </Header>
              <Content
                style={{
                  overflowY: "scroll",
                  height: "89vh",
                  scrollbarWidth: "none",
                }}
              >
                <div>
                  <Outlet />
                </div>
              </Content>
            </Layout>
          </div>
        )}

        <HelpModal
          show={this.state.showHelpModal}
          closeModal={() => this.setState({ showHelpModal: false })}
        />

        {this.state.showNotificationModal && (
          <Modal
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingRight: "20px",
                }}
              >
                <span>
                  {this.context.translate("_FLEET_DASHBORD_RULETRIGGER_TITLE_")}
                </span>

                <Button
                  style={{
                    borderRadius: "6px",
                    border: "1px solid red",
                    background: "none",
                    color: "red",
                    padding: "2px 6px 4px 6px",
                    fontSize: "14px",
                  }}
                  onClick={() => this.dismissNotification()}
                >
                  Dismiss
                </Button>
              </div>
            }
            // title={this.context.translate("_FLEET_DASHBORD_RULETRIGGER_TITLE_")}
            open={this.state.showNotificationModal}
            onCancel={() => this.setState({ showNotificationModal: false })}
            footer={null}
            style={{ minWidth: "900px" }}
          >
            {/* <Button
              style={{
                float: "right",
                position: "relative",
                right: "46px",
                bottom: "36px",
                borderRadius: "6px",
                border: "1px solid red",
                background: "none",
                color: "red",
                padding: "2px 6px 4px 6px",
                fontSize: "14px",
              }}
              onClick={() => this.dismissNotification()}
            >
              Dismiss
            </Button> */}
            <div style={{ height: "450px" }}>
              <Table
                scroll={{ y: 350 }}
                columns={this.state.columns}
                dataSource={this.menuSettingStore.notificationRuleData}
                rowSelection={{
                  selectedRowKeys: this.state.selectedNotificationId,
                  onChange: async (selectedRowKeys, selectedRows) => {
                    await this.setState({
                      selectedNotificationId: selectedRowKeys,
                    });
                  },
                }}
                rowKey="id"
              />
            </div>
          </Modal>

        )}
        {/* {console.log("count", this.state.sosnotificationCount > 0, "path", this.props.location.pathname.replace(/^\//, ""))} */}
        {(this.state.sosnotificationCount > 0 && this.props.location.pathname.replace(/^\//, "") === "livetracking") &&
          (
            <SosAlertNotification
              notifyData={(this.sosAlertStore.sosAlertList)}
              user={this.state.user}
              getSOSAlert={this.getSOSAlert}

            />

          )

        }


      </>
    );
  }
}
Menu3.contextType = StoreContext;
export default observer(withRouter(Menu3));
